import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { CSSTransitionGroup } from 'react-transition-group';
import cls from 'classnames';
import { MinimizeIcon } from '@bizzabo/icons';

const AnimatedRestriction = ({
    children,
    minimize,
    customColor,
    transitionName,
    transitionEnterTimeout=200,
    transitionLeaveTimeout=200,
    isVisible,
    isMinimized,
}) => (
    <CSSTransitionGroup
        transitionName={transitionName}
        transitionEnterTimeout={transitionEnterTimeout}
        transitionLeaveTimeout={transitionLeaveTimeout}
    >
        {
            isVisible ? (
                <div className={cls('animated-alert color-1-border', {isMinimized})} key={isMinimized}>
                    <OverlayTrigger
                        overlay={<Tooltip id="minimize-tooltip">Minimize</Tooltip>}
                        placement="bottom"
                        delayShow={500}
                    >
                        <button className="close-btn" onClick={minimize}>
                            <MinimizeIcon color={customColor} fontSize="16px" />
                        </button>
                    </OverlayTrigger>
                    {children}
                </div>
            ) : null
        }
    </CSSTransitionGroup>
);

export default AnimatedRestriction;
